import { CommonGet, CommonPost } from "../../../../utils/CommonFetch";

export default {
    getCardPrintDetails,
    getAlGroupsForDropdown,
    getAllOperationEntitiesForDropDown,
    GetCollectionPointsFilter,
    updateStatus,
    getEmployeeTypesData
};

async function getAlGroupsForDropdown() {
    var groupArray = [];

    const response = await CommonGet('/api/Group/GetAllGroups', null)
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"]
        }
    }
    return groupArray;
}

async function getAllOperationEntitiesForDropDown(groupID) {
    var operationEntityArray = [];
    var response = await CommonGet('/api/OperationEntity/GetOperationEntityByGroupIDEntityID', 'groupID=' + groupID);
    for (let item of Object.entries(response.data)) {
        operationEntityArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"];
    }
     return operationEntityArray;
}

async function GetCollectionPointsFilter(operationEntityID) {
    var collectionPointArray = [];
    var response = await CommonGet('/api/CollectionPoint/GetCollectionPointByOperationEntityId', 'operationEntityID=' + operationEntityID);

    for (let item of Object.entries(response.data)) {
        collectionPointArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"];
    }
    return collectionPointArray;
}

async function getCardPrintDetails(collectionPointID, employeeTypeID, isRsm) {
    const res = await CommonGet('/api/EmployeeCardManagement/GetEmployeeCardsToPrint', 'collectionPointID=' + collectionPointID + '&employeeTypeID=' + employeeTypeID + '&isRsm=' + isRsm);
    return res.data;
}

async function updateStatus(cardUpdate, cardPrintFilter) {
    let printCard = {
        cardStatusUpdateModel: cardUpdate,
        GroupID: parseInt(cardPrintFilter.groupID),
        OperationEntityID: parseInt(cardPrintFilter.operationEntityID),
        CollectionPointID: parseInt(cardPrintFilter.collectionPointID),
    }

    const response = await CommonPost('/api/EmployeeCardManagement/UpdateEmployeeCardsToPrint', null, printCard);
    return response;
}

async function getEmployeeTypesData() {
    var response = await CommonGet('/api/EnumData/GetEmployeeTypeEnumData', null);
    let array = []
    for (let item of Object.entries(response.data)) {
        array[item[1]["key"]] = item[1]["value"]
    }
    return array;
}

